import { render, staticRenderFns } from "./sale-by-customer-summary.vue?vue&type=template&id=6aa371e4"
import script from "./sale-by-customer-summary.vue?vue&type=script&lang=js"
export * from "./sale-by-customer-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports